(function () {
  'use strict';
  var root = document.querySelector('[data-library-member][data-signed-in="true"]');
  if (!root || !root.dataset.meUrl) return;
  var block = root.querySelector('[data-mb-strings]');
  if (!block) return;
  var strings;
  try { strings = JSON.parse(block.textContent); } catch (e) { return; }
  var reader = 1;
  try { reader = Number(localStorage.getItem('loa-reader')) || 1; } catch (e) {}
  var empty = false;
  var cache = Object.create(null);
  function q(s, parent) { return (parent || root).querySelector(s); }
  function fill(key, values) {
    return (strings[key] || '').replace(/%([A-Z]+)%/g, function (_, k) {
      return values && values[k.toLowerCase()] != null ? String(values[k.toLowerCase()]) : '';
    });
  }
  function request(url, text) {
    return fetch(url, {credentials: 'same-origin', headers: {Accept: 'application/json'}}).then(function (r) {
      if (!r.ok) throw new Error();
      return text ? r.text() : r.json();
    });
  }
  function el(tag, cls, parent, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    if (parent) parent.appendChild(node);
    return node;
  }
  if (root.dataset.mbPage === 'membership') {
    if (root.dataset.statsUrl) request(root.dataset.statsUrl).then(function (data) {
      var books = q('[data-mb-t-books]');
      var hours = q('[data-mb-t-hours]');
      var h = Math.floor(Number(data.listen_seconds) / 3600);
      if (Number(data.titles) > 0) {
        q('b', books).textContent = data.titles;
        q('span', books).textContent = fill(Number(data.titles) === 1 ? 't_book_1' : 't_books');
        books.hidden = false;
      }
      if (isFinite(h) && h >= 1) {
        q('b', hours).textContent = fill('t_hours', {h: h});
        q('span', hours).textContent = fill('t_listen');
        hours.hidden = false;
      }
      if (!books.hidden || !hours.hidden) q('[data-mb-since]').hidden = false;
    }).catch(function () {});
    request(root.dataset.meUrl).then(function (data) {
      var m = data.member;
      var plan = q('[data-mb-plan]');
      // A17 (HH-1): Skio's portal is the default; a Seal-era plan (the ledger's plan kind "legacy") manages in Seal's
      var manage = q('[data-mb-manage]');
      if (manage && m && m.plan === 'legacy' && manage.dataset.legacyHref) manage.setAttribute('href', manage.dataset.legacyHref);
      if (data.signed_in === false || !m || !plan || ['yearly', 'monthly'].indexOf(m.plan) === -1) return;
      q('.p', plan).textContent = m.plan === 'yearly' ? plan.dataset.perDayYearly : plan.dataset.perDayMonthly;
      q('.u', plan).textContent = fill('a_day_' + m.plan);
      var value = m.status === 'cancelled' ? m.access_until : m.next_payment_at;
      if (!value) return;
      var date = new Date(value);
      if (isNaN(date.getTime())) return;
      var lang = root.dataset.lang || 'en';
      var formatted = new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : lang, {year: 'numeric', month: 'long', day: 'numeric'}).format(date);
      var dl = q('[data-mb-dl]', plan);
      q('dt', dl).textContent = fill(m.status === 'cancelled' ? 'ends_on' : 'renews_on');
      q('dd', dl).textContent = formatted;
      dl.hidden = false;
    }).catch(function () {});
    return;
  }
  function href(p) {
    return root.dataset.enterUrl + '?next=' + encodeURIComponent('/' + p.lang + '/' + p.mode + '/' + p.title + '/' + p[p.mode].chapter);
  }
  function where(p) {
    if (p.mode === 'read' && typeof p.chapter_title === 'string' && p.chapter_title.trim()) return fill('where_read', {title: p.chapter_title.trim(), chapter: p.read.chapter, total: p.chapters});
    if (p.mode === 'listen' && p.left_seconds != null) {
      var minutes = Math.floor(Math.max(0, Number(p.left_seconds)) / 60);
      return fill('where_listen', {left: minutes >= 60 ? fill('hm', {h: Math.floor(minutes / 60), m: minutes % 60}) : fill('m', {m: minutes})});
    }
    if (p.mode === 'listen') return fill('where_nl');
    return fill('where_n');
  }
  function progress(bar, p) {
    var n = Math.round(Math.max(0, Math.min(1, Number(p.progress) || 0)) * 100);
    bar.setAttribute('aria-valuenow', String(n));
    bar.querySelector('i').style.width = n + '%';
  }
  function resolve(handle) {
    var suffix = root.dataset.handleSuffix;
    if (!suffix) return Promise.resolve(handle);
    var key = 'loa-member-handle:' + handle + suffix;
    if (cache[key]) return cache[key];
    var saved;
    try { saved = sessionStorage.getItem(key); } catch (e) {}
    if (saved === handle || saved === handle + suffix) return Promise.resolve(saved);
    cache[key] = request('/products/' + encodeURIComponent(handle + suffix) + '.js').then(function () {
      return handle + suffix;
    }, function () { return handle; }).then(function (value) {
      try { sessionStorage.setItem(key, value); } catch (e) {}
      return value;
    });
    return cache[key];
  }
  function shelf(handle, places, resolved) {
    request('/products/' + encodeURIComponent(handle) + '?section_id=library-v16-next-shelf', true).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var source = doc.querySelector('[data-next-shelf]');
      if (!source) return;
      var excluded = [];
      places.forEach(function (p, i) { excluded.push(p.handle, resolved[i]); });
      var count = 0;
      Array.prototype.forEach.call(source.querySelectorAll('a.book'), function (a) {
        var path = (a.getAttribute('href') || '').split('?')[0].split('/products/')[1];
        if (excluded.indexOf(path) !== -1 || count >= 12) a.remove();
        else count++;
      });
      if (!count) return;
      var body = q('[data-mb-next-body]');
      while (source.firstChild) body.appendChild(source.firstChild);
      q('[data-mb-next]').hidden = false;
    }).catch(function () {});
  }
  function addPlaces(places) {
    var rail = q('[data-mb-rail]');
    places.forEach(function (p) {
      if (!p[p.mode]) return;
      var item = el('div', 'mb16-it', rail);
      var book = el('a', 'mb16-bk', item);
      book.setAttribute('href', href(p));
      if (p.cover) {
        var image = el('img', '', el('span', 'cv', book));
        image.setAttribute('src', p.cover);
        image.setAttribute('width', '150');
        image.setAttribute('height', '225');
        image.setAttribute('alt', '');
        image.setAttribute('loading', 'lazy');
        image.setAttribute('decoding', 'async');
      }
      el('b', '', book, p.name);
      el('span', 'where', book, where(p));
      var bar = el('span', 'mb16-bar', book);
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-label', q('[data-mb-now] .mb16-bar').getAttribute('aria-label'));
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '100');
      el('i', '', bar);
      progress(bar, p);
      var print = el('a', 'mb16-pr', item, fill('print_it'));
      print.hidden = true;
      var take = null;
      var takeText = fill('dl_it');
      if (takeText) {
        take = el('a', 'mb16-pr mb16-take', item, takeText);
        take.hidden = true;
        take.style.marginBlockStart = '0';
      }
      resolve(p.handle).then(function (handle) {
        print.setAttribute('href', '/products/' + handle);
        print.hidden = false;
        if (take && p.handle) {
          take.setAttribute('href', '/products/' + handle + '#download');
          take.hidden = false;
        }
      }).catch(function () {});
    });
    if (rail.firstChild) q('[data-mb-continue-sec]').hidden = false;
  }
  if (root.dataset.readersUrl) request(root.dataset.readersUrl).then(function (data) {
    if (!Array.isArray(data.readers)) return;
    var active = data.readers.filter(function (r) { return Number(r.reader) === reader; })[0];
    if (!active || !active.name) return;
    if (!empty) q('[data-mb-title]').textContent = fill('welcome_name', {name: active.name});
  }).catch(function () {});
  var limit = Number(root.dataset.placesLimit);
  if (!Number.isInteger(limit) || limit < 1 || limit > 50) limit = 6;
  var all = q('[data-mb-all]');
  var shown = 0;
  var allAsked = false;
  function placesUrl(n) {
    return root.dataset.placesUrl + '?reader=' + reader + '&limit=' + n;
  }
  if (all && !all.hasAttribute('data-mb-books')) all.addEventListener('click', function (event) {   // LIB-1 (D204): with the page My books, "See all" is a link to it (data-mb-books) and nothing intercepts the click
    event.preventDefault();
    if (allAsked || all.hidden) return;
    allAsked = true;
    request(placesUrl(50)).then(function (data) {
      if (!Array.isArray(data.places)) return;
      addPlaces(data.places.slice(shown, 50));
      all.hidden = true;
    }).catch(function () {});
  });
  if (root.dataset.placesUrl) request(placesUrl(limit)).then(function (data) {
    if (!Array.isArray(data.places)) return;
    var places = data.places.slice(0, limit);
    shown = places.length;
    if (!places.length) {
      empty = true;
      q('[data-mb-title]').textContent = fill('your_library');
      return;
    }
    var newest = places[0];
    if (!newest[newest.mode]) return;
    var cont = q('[data-mb-continue]');
    cont.textContent = fill('continue', {title: newest.name});
    cont.setAttribute('href', href(newest));
    cont.hidden = false;
    var now = q('[data-mb-now]');
    now.setAttribute('href', href(newest));
    now.setAttribute('aria-label', cont.textContent);
    if (newest.cover) q('img', now).setAttribute('src', newest.cover);
    else q('img', now).hidden = true;
    q('.where', now).textContent = where(newest);
    progress(q('.mb16-bar', now), newest);
    now.hidden = false;
    addPlaces(places.slice(1));
    if (all) all.hidden = !(data.places.length >= limit && limit < 50);
    if (all && !all.hidden) q('[data-mb-continue-sec]').hidden = false;
    Promise.all(places.map(function (p) { return resolve(p.handle); })).then(function (handles) {
      shelf(handles[0], places, handles);
    }).catch(function () {});
  }).catch(function () {});
  request(root.dataset.meUrl).then(function (data) {
    var m = data.member;
    var plan = q('[data-mb-plan]');
    if (data.signed_in === false || !m || !plan || ['yearly', 'monthly'].indexOf(m.plan) === -1) return;
    q('.p', plan).textContent = m.plan === 'yearly' ? plan.dataset.perDayYearly : plan.dataset.perDayMonthly;
    q('.u', plan).textContent = fill('a_day_' + m.plan);
    var value = m.status === 'cancelled' ? m.access_until : m.next_payment_at;
    if (!value) return;
    var date = new Date(value);
    if (isNaN(date.getTime())) return;
    var lang = root.dataset.lang || 'en';
    var formatted = new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : lang, {year: 'numeric', month: 'long', day: 'numeric'}).format(date);
    var renews = q('[data-mb-renews]', plan);
    renews.textContent = fill(m.status === 'cancelled' ? 'ends' : 'renews', {date: formatted});
    renews.hidden = false;
  }).catch(function () {});
}());
